import {
  mutationErrorHandler,
  queryErrorHandler,
} from '@/lib/utils/refreshTokenHandler';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

export function getContext() {
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: queryErrorHandler,
    }),
    mutationCache: new MutationCache({
      onError: mutationErrorHandler,
    }),
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Don't retry 401 errors - they're handled by the error handler
          const httpError = error as { response?: { status?: number } };
          if (httpError.response?.status === 401) {
            return false;
          }
          return failureCount < 3;
        },
      },
      mutations: {
        retry: (failureCount, error) => {
          // Don't retry 401 errors automatically - they're handled by the error handler
          const httpError = error as { response?: { status?: number } };
          if (httpError.response?.status === 401) {
            return false;
          }
          return failureCount < 1;
        },
      },
    },
  });
  return {
    queryClient,
  };
}

export function ReactQueryProvider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient: QueryClient;
}) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
